export default "__VITE_ASSET__DFeIz3zj__"